import { render } from "./whatisAi.vue?vue&type=template&id=e3ac8b14&scoped=true"
import script from "./whatisAi.vue?vue&type=script&lang=js"
export * from "./whatisAi.vue?vue&type=script&lang=js"

import "./whatisAi.vue?vue&type=style&index=0&id=e3ac8b14&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3ac8b14"]])

export default __exports__